import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Button, Card, CardDescription, CardHeader, CardTitle } from '@monigo/ui';

export function KycRejectedPage() {
  const { t } = useTranslation();
  // For direct access to /kyc/rejected, we read the reason from query params or show generic
  const params = new URLSearchParams(window.location.search);
  const reason = params.get('reason') ?? t('kyc.noReason');

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('kyc.rejectedTitle')}</CardTitle>
        <CardDescription>{t('kyc.rejectedBody', { reason })}</CardDescription>
      </CardHeader>
      <div className="px-5 pb-5">
        <Link to="/kyc">
          <Button>{t('kyc.retryCta')}</Button>
        </Link>
      </div>
    </Card>
  );
}
